
const BILLING_API = {
    BILLING_EDIT_LOAD: "api/report/billingDetails",
};

export default BILLING_API;
